export const eventsList = {
  /**
   * @summary List of possible folders events
   * @enum
   * @memberof mediaManagerSDK.events
   */
  FOLDERS: {
    LIST: 'folders.list',
    TREE: 'folders.tree',
    REMOVE: 'folders.remove',
    SEARCH: 'folders.search',
    /**
     * @summary List of possible trashed folders events
     * @enum
     * @memberof mediaManagerSDK.events.folders
     */
    TRASH: {
      LIST: 'folders.trash.list',
      RESTORE: 'folders.trash.restore',
      REMOVE: 'folders.trash.remove',
      SEARCH: 'folders.trash.search'
    }
  },
  /**
   * @summary List of possible folder events
   * @enum
   * @memberof mediaManagerSDK.events
   */
  FOLDER: {
    CREATE: 'folder.create',
    UPDATE: 'folder.update',
    GET: 'folder.get'
  },
  /**
   * @summary List of possible items events
   * @enum
   * @memberof mediaManagerSDK.events
   */
  ITEMS: {
    GET: 'items.get',
    LIST: 'items.list',
    LIGHT_LIST: 'items.lightList',
    REMOVE: 'items.remove',
    RECENT: 'items.recent',
    SEARCH: 'items.search',
    SEARCH_BY_TAG: 'items.searchByTag',
    COPY: 'items.copy',
    MOVE: 'items.move',
    ADD: 'items.add',
    IMPORT_TO_SITE: 'items.importToSite',
    /**
     * @summary List of possible trashed items events
     * @enum
     * @memberof mediaManagerSDK.events.items
     */
    TRASH: {
      LIST: 'items.trash.list',
      RESTORE: 'items.trash.restore',
      REMOVE: 'items.trash.remove',
      SEARCH: 'folders.trash.search'
    },
    /**
     * @summary List of possible site_media items events
     * @enum
     * @memberof mediaManagerSDK.events.items
     */
    SITE_MEDIA: {
      LIST: 'items.siteMedia.list',
      REMOVE: 'items.siteMedia.remove',
      ADD: 'items.siteMedia.add'
    }
  },
  /**
   * @summary List of possible item events
   * @enum
   * @memberof mediaManagerSDK.events
   */
  ITEM: {
    GET: 'item.get',
    UPDATE: 'item.update',
    UPLOAD: 'item.upload',
    UPLOAD_RESUMABLE: 'item.uploadResumable',
    UPLOAD_BY_URL: 'item.uploadByUrl',
    IMPORT_ASYNC: 'item.importAsync',
    GET_DOWNLOAD_URL: 'item.getDownloadUrl'
  },
  /**
   * @summary List of possible source events
   * @enum
   * @memberof mediaManagerSDK.events
   */
  SOURCE: {
    GET_BOARDS: 'source.getBoards'
  },
  /**
   * @summary List of possible user events
   * @enum
   * @memberof mediaManagerSDK.events
   */
  USER: {
    GET: 'user.get',
    GET_SITES_INFO: 'user.getSitesInfo',
    GET_MANAGER_INFO: 'user.getManagerInfo'
  },
  /**
   * @summary List of possible trash events
   * @enum
   * @memberof mediaManagerSDK.events
   */
  TRASH: {
    REMOVE: 'trash.remove',
    RESTORE: 'trash.restore',
    EMPTY: 'trash.empty'
  },
  /**
   * @summary List of possible recommended preferences events
   * @enum
   * @memberOf mediaManagerSDK.events
   */
  PREFERENCES: {
    MEDIA_CATEGORIES: 'preferences.mediaCategories',
    UPDATE_MEDIA_CATEGORIES: 'preferences.updateMediaCategories'
  },
  /**
   * @summary List of possible recommended info events
   * @enum
   * @memberOf mediaManagerSDK.events
   */
  TOPICS: {
    LIST: 'topics.list'
  },
  MULTI_SEARCH: {
    SEARCH: 'multiSearch.search'
  }
};